<template>
  <!-- Begin page -->
  <div id="layout-wrapper">
    <NavigationBar/>

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">
          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <div class="row align-items-center">
                  <div class="col-md-6">
                    <h4 class="mb-sm-0 font-size-18">Terminations</h4>
                  </div>
                  <div class="col-md-6">
                    <div class="ms-3">
                      <select class="form-select" aria-label="Select Month" @change="handleMonthChange">
                        <option value="">Select Month</option>
                        <option value="1">January</option>
                        <option value="2">February</option>
                        <option value="3">March</option>
                        <option value="4">April</option>
                        <option value="5">May</option>
                        <option value="6">June</option>
                        <option value="7">July</option>
                        <option value="8">August</option>
                        <option value="9">September</option>
                        <option value="10">October</option>
                        <option value="11">November</option>
                        <option value="12">December</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                    <li class="breadcrumb-item active">HR Actions</li>
                    <li class="breadcrumb-item active">Meetings</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- stats cards -->
          <div class="row">
            <!-- Total Terminations -->
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Total Terminations</p>
                      <h5 class="mb-0">{{ statistics.totalTerminations }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-info rounded-circle text-white font-size-20">
                        <i class="mdi mdi-account-remove"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Resignation Terminations -->
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Resignation Terminations</p>
                      <h5 class="mb-0">{{ statistics.resignations }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-success rounded-circle text-white font-size-20">
                        <i class="mdi mdi-account-arrow-right"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Dismissal Terminations -->
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Dismissal Terminations</p>
                      <h5 class="mb-0">{{ statistics.dismissals }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-warning rounded-circle text-white font-size-20">
                        <i class="mdi mdi-account-cancel"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Transfers Terminations -->
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Transfers Terminations</p>
                      <h5 class="mb-0">{{ statistics.transfers }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-primary rounded-circle text-white font-size-20">
                        <i class="mdi mdi-account-switch"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Death Terminations -->
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Death Terminations</p>
                      <h5 class="mb-0">{{ statistics.deaths }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-danger rounded-circle text-white font-size-20">
                        <i class="mdi mdi-account-remove-outline"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Other Terminations -->
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Other Terminations</p>
                      <h5 class="mb-0">{{ statistics.others }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-secondary rounded-circle text-white font-size-20">
                        <i class="mdi mdi-account-question"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Pending Terminations -->
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Pending Terminations</p>
                      <h5 class="mb-0">{{ statistics.pending }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-danger rounded-circle text-white font-size-20">
                        <i class="mdi mdi-clock-outline"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- end of stats -->

          <!-- Notification Toast -->
          <div class="position-fixed bottom-0 end-0 p-3" style="z-index: 11">
            <div id="notification-toast" class="toast hide" :class="{'show': message}" role="alert" aria-live="assertive" aria-atomic="true">
              <div class="toast-header" :class="message && message.includes('success') ? 'bg-success text-white' : 'bg-danger text-white'">
                <strong class="me-auto">{{ message && message.includes('success') ? 'Success' : 'Error' }}</strong>
                <button type="button" class="btn-close" @click="message = ''" aria-label="Close"></button>
              </div>
              <div class="toast-body">
                {{ message }}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <div class="flex-grow-1">
                      <div class="search-box mb-0 me-3">
                        <div class="position-relative">
                          <input type="text" class="form-control bg-light border-light rounded"
                                 placeholder="Search..." @input="handleSearch">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex">
                      <div class="d-flex align-items-center me-3 pe-3">
                        <div>
                          <div class="float-end d-flex ">
                            <div class="input-group fw-semibold text-uppercase me-3">
                              <label class="input-group-text text-uppercase">Department</label>
                              <select class="form-select" style="width: 200px;" @change="handleDepartmentChange">
                                <option selected="selected" value="">All Departments</option>
                                <option v-for="department in departments" :key="department.id" :value="department.id">
                                  {{ department.departmentName }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button data-bs-toggle="modal" data-bs-target=".download-modal" type="button" class="btn btn-primary dropdown-toggle option-selector me-3 text-capitalize">
                        <i class="bx bxs-download"></i> <span class="pl-1 d-md-inline">Download Report</span>
                      </button>

                      <!-- Create Termination Button -->
                      <button data-bs-toggle="modal" data-bs-target="#modal-add-termination" type="button" class="btn btn-success dropdown-toggle option-selector me-3 text-capitalize">
                        <i class="bx bx-plus"></i> <span class="pl-1 d-md-inline">Create Termination</span>
                      </button>

                      <!-- Clearance Report Button -->
                      <button @click="generateClearanceReport" type="button" class="btn btn-info dropdown-toggle option-selector text-capitalize">
                        <i class="bx bx-check-circle"></i> <span class="pl-1 d-md-inline">Clearance Report</span>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <div v-if="isLoading" class="text-center my-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                  <div v-else class="table-responsive">
                    <table class="table align-middle table-hover contacts-table table-striped text-nowrap" id="datatable-buttons">
                      <thead class="table-light">
                      <tr class="table-dark">
                        <th scope="col">Employee Name</th>
                        <th scope="col">Separation Type</th>
                        <th scope="col">Termination Date</th>
                        <th scope="col">Last Working Day</th>
                        <th scope="col">Description</th>
                        <th scope="col">Department</th>
                        <th scope="col">Status</th>
                        <th scope="col">Documents</th>
                        <th scope="col">Clearance</th>
                        <th scope="col">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="item in terminationsData" :key="item.id">
                        <th>
                          <div>{{ item.employeeName || 'N/A' }}</div>
                          <small class="text-muted">ID: {{ item.employeeId }}</small>
                        </th>
                        <td>
                          <span class="badge rounded-pill" :class="{
                            'bg-success': item.separationType === 'Resignation',
                            'bg-danger': item.separationType === 'Death',
                            'bg-primary': item.separationType === 'Transfers',
                            'bg-warning': item.separationType === 'Dismissal',
                            'bg-secondary': item.separationType === 'Other'
                          }">
                            {{ item.separationType }}
                          </span>
                        </td>
                        <td>{{ formatDate(item.terminationDate) }}</td>
                        <td>{{ formatDate(item.lastWorkingDay) }}</td>
                        <td>
                          <div class="text-truncate" style="max-width: 150px;" :title="item.description">
                            {{ item.description }}
                          </div>
                        </td>
                        <td>
                          <div>{{ item.departmentName }}</div>
                          <small class="text-muted" v-if="item.departmentID">ID: {{ item.departmentID }}</small>
                        </td>
                        <td>
                          <span class="badge" :class="getStatusBadgeClass(item.status)">
                            {{ formatStatus(item.status) }}
                          </span>
                          <div class="text-muted small mt-1" v-if="item.status && item.status.toLowerCase() === 'approved' && item.approvedAt">
                            {{ formatDateWithTime(item.approvedAt) }}
                          </div>
                          <div class="text-muted small mt-1" v-if="item.status && item.status.toLowerCase() === 'rejected' && item.rejectedAt">
                            {{ formatDateWithTime(item.rejectedAt) }}
                          </div>
                        </td>
                        <td>
                          <template v-if="item.documents && item.documents.length > 0">
                            <div class="document-container">
                              <div class="d-flex align-items-center">
                                <span class="badge bg-info me-2">{{ item.documents.length }} document{{ item.documents.length > 1 ? 's' : '' }}</span>
                                <button
                                    type="button"
                                    class="btn btn-sm btn-outline-primary"
                                    @click="viewDocuments(item.documents)"
                                >
                                  <i class="mdi mdi-file-document-outline me-1"></i> View All
                                </button>
                              </div>
                            </div>
                          </template>
                          <span v-else>No documents</span>
                        </td>
                        <td>
                          <button
                              type="button"
                              class="btn btn-sm btn-outline-info"
                              @click="viewClearanceStatus(item)"
                          >
                            <i class="mdi mdi-check-circle-outline me-1"></i> View Status
                          </button>
                        </td>
                        <td>
                          <div class="d-flex">
                            <button
                                v-if="!item.status || item.status.toLowerCase() === 'pending'"
                                @click="showConfirmationModal(item.id, 'approve')"
                                class="btn btn-sm btn-success me-2">
                              Approve
                            </button>
                            <button
                                v-if="!item.status || item.status.toLowerCase() === 'pending'"
                                @click="showConfirmationModal(item.id, 'reject')"
                                class="btn btn-sm btn-danger">
                              Reject
                            </button>
                            <span v-if="item.status && item.status.toLowerCase() !== 'pending'">
                              {{ item.status.toLowerCase() === 'approved' ? 'Approved by ' + (item.approvedBy || 'Admin') : '' }}
                              {{ item.status.toLowerCase() === 'rejected' ? 'Rejected by ' + (item.rejectedBy || 'Admin') : '' }}
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="terminationsData.length === 0">
                        <td colspan="9" class="text-center">No termination records found</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Create Termination Modal -->
      <div class="modal fade" id="modal-add-termination" tabindex="-1" aria-labelledby="addTerminationModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="addTerminationModalLabel">Create Termination</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <form id="addTerminationForm" @submit="submitTermination">
                <div class="row">
                  <!-- Select Employee -->
                  <div class="col-md-6 mb-3">
                    <label for="selectEmployee" class="form-label">Select Employee</label>
                    <select class="form-control" id="selectEmployee" required>
                      <option value="">Select Employee</option>
                      <option v-for="employee in employees" :key="employee.id" :value="employee.id">
                        {{ employee.name }}
                      </option>
                    </select>
                  </div>
                  <!-- Separation Type -->
                  <div class="col-md-6 mb-3">
                    <label for="separationType" class="form-label">Separation Type</label>
                    <select class="form-control" id="separationType" required>
                      <option value="">Select separation type</option>
                      <option value="Resignation">Resignation</option>
                      <option value="Death">Death</option>
                      <option value="Transfers">Transfers</option>
                      <option value="Dismissal">Dismissal</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <!-- Separation Date -->
                  <div class="col-md-6 mb-3">
                    <label for="separationDate" class="form-label">Separation Date</label>
                    <input type="date" class="form-control" id="separationDate" :value="new Date().toISOString().substr(0, 10)" required>
                  </div>
                  <!-- Last Working Day -->
                  <div class="col-md-6 mb-3">
                    <label for="lastWorkingDay" class="form-label">Last Working Day</label>
                    <input type="date" class="form-control" id="lastWorkingDay" :value="new Date().toISOString().substr(0, 10)" required>
                  </div>
                  <!-- Description -->
                  <div class="col-md-12 mb-3">
                    <label for="description" class="form-label">Description</label>
                    <textarea class="form-control" id="description" rows="3" placeholder="Enter Description"></textarea>
                  </div>

                  <!-- Clearance from Company Section -->
                  <div class="col-md-12 mb-3">
                    <div class="card">
                      <div class="card-header bg-light">
                        <h6 class="mb-0">Company Clearance</h6>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="mb-3">
                              <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="itClearance">
                                <label class="form-check-label" for="itClearance">
                                  IT Department Clearance
                                </label>
                              </div>
                              <small class="text-muted">Returned all company devices, access cards, etc.</small>
                            </div>

                            <div class="mb-3">
                              <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="financeClearance">
                                <label class="form-check-label" for="financeClearance">
                                  Finance Department Clearance
                                </label>
                              </div>
                              <small class="text-muted">Settled all pending accounts, advances, etc.</small>
                            </div>

                            <div class="mb-3">
                              <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="hrClearance">
                                <label class="form-check-label" for="hrClearance">
                                  HR Department Clearance
                                </label>
                              </div>
                              <small class="text-muted">Completed exit interview, handover notes, etc.</small>
                            </div>
                          </div>

                          <div class="col-md-6">
                            <div class="mb-3">
                              <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="adminClearance">
                                <label class="form-check-label" for="adminClearance">
                                  Admin Department Clearance
                                </label>
                              </div>
                              <small class="text-muted">Returned office keys, parking cards, etc.</small>
                            </div>

                            <div class="mb-3">
                              <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="deptClearance">
                                <label class="form-check-label" for="deptClearance">
                                  Department Head Clearance
                                </label>
                              </div>
                              <small class="text-muted">Completed knowledge transfer, handover, etc.</small>
                            </div>

                            <div class="mb-3">
                              <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="securityClearance">
                                <label class="form-check-label" for="securityClearance">
                                  Security Department Clearance
                                </label>
                              </div>
                              <small class="text-muted">Returned ID badge, security tokens, etc.</small>
                            </div>
                          </div>
                        </div>

                        <div class="row mt-2">
                          <div class="col-md-12">
                            <div class="mb-3">
                              <label for="clearanceNotes" class="form-label">Clearance Notes</label>
                              <textarea class="form-control" id="clearanceNotes" rows="2" placeholder="Enter any specific notes about clearance status"></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Documents -->
                  <div class="col-md-12 mb-3">
                    <label for="uploadDocuments" class="form-label">Upload Documents</label>
                    <input type="file" class="form-control" id="uploadDocuments" multiple>
                    <small class="text-muted">Upload resignation letter, clearance forms, exit interview, etc.</small>
                  </div>
                </div>
                <!-- Message Alert -->
                <div v-if="message" class="alert" :class="message.includes('successfully') ? 'alert-success' : 'alert-danger'">
                  {{ message }}
                </div>
                <!-- Modal Footer -->
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                  <button type="submit" class="btn btn-primary" :disabled="isLoading">
                    <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Save Termination
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Confirmation Modal -->
      <div class="modal fade" id="confirmation-modal" tabindex="-1" aria-labelledby="confirmationModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header" :class="confirmationType === 'approve' ? 'bg-success text-white' : 'bg-danger text-white'">
              <h5 class="modal-title" id="confirmationModalLabel">
                {{ confirmationType === 'approve' ? 'Approve Termination' : 'Reject Termination' }}
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p>
                <strong>Are you sure you want to {{ confirmationType === 'approve' ? 'approve' : 'reject' }} this termination?</strong>
              </p>
              <p>This action cannot be undone.</p>

              <!-- Display termination information -->
              <div v-if="selectedTermination" class="card mt-3">
                <div class="card-header bg-light">
                  <h6 class="mb-0">Termination Details</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <p class="mb-2"><strong>Employee:</strong> {{ selectedTermination.employeeName || 'N/A' }}</p>
                      <p class="mb-2"><strong>Separation Type:</strong> {{ selectedTermination.separationType }}</p>
                      <p class="mb-2"><strong>Department:</strong> {{ selectedTermination.departmentName }}</p>
                    </div>
                    <div class="col-md-6">
                      <p class="mb-2"><strong>Termination Date:</strong> {{ formatDate(selectedTermination.terminationDate) }}</p>
                      <p class="mb-2"><strong>Last Working Day:</strong> {{ formatDate(selectedTermination.lastWorkingDay) }}</p>
                      <p class="mb-2"><strong>Created:</strong> {{ formatDateWithTime(selectedTermination.createdAt) }}</p>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12">
                      <p class="mb-1"><strong>Description:</strong></p>
                      <p class="bg-light p-2 rounded">{{ selectedTermination.description }}</p>
                    </div>
                  </div>
                  <div class="row mt-2" v-if="selectedTermination.documents && selectedTermination.documents.length > 0">
                    <div class="col-12">
                      <p class="mb-1"><strong>Documents ({{ selectedTermination.documents.length }}):</strong></p>
                      <ul class="list-group">
                        <li v-for="(doc, index) in selectedTermination.documents" :key="index" class="list-group-item d-flex justify-content-between align-items-center">
                          <span class="text-truncate me-3">{{ doc.documentName }}</span>
                          <a :href="doc.documentPath" target="_blank" class="btn btn-sm btn-outline-primary">
                            <i class="mdi mdi-eye"></i> View
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button
                  type="button"
                  :class="confirmationType === 'approve' ? 'btn btn-success' : 'btn btn-danger'"
                  :disabled="isProcessingAction"
                  @click="confirmAction">
                <span v-if="isProcessingAction" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                {{ confirmationType === 'approve' ? 'Confirm Approval' : 'Confirm Rejection' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Documents Viewer Modal -->
      <div class="modal fade" id="documents-modal" tabindex="-1" aria-labelledby="documentsModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="documentsModalLabel">Documents</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div v-if="currentDocuments && currentDocuments.length > 0">
                <div class="table-responsive">
                  <table class="table table-bordered table-hover">
                    <thead class="table-light">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Document Name</th>
                      <th scope="col">Upload Date</th>
                      <th scope="col">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(doc, index) in currentDocuments" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ doc.documentName }}</td>
                      <td>{{ formatDateWithTime(doc.uploadedAt) }}</td>
                      <td>
                        <div class="d-flex">
                          <a :href="doc.documentPath" target="_blank" class="btn btn-sm btn-primary me-2">
                            <i class="mdi mdi-eye"></i> View
                          </a>
                          <a :href="doc.documentPath" download class="btn btn-sm btn-success">
                            <i class="mdi mdi-download"></i> Download
                          </a>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-else class="text-center p-4">
                <div class="alert alert-warning">No documents available for this termination.</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- END layout-wrapper -->

    <!-- Right bar overlay-->
    <div class="rightbr-overlay"></div>

    <!-- Documents Viewer Modal -->
    <div class="modal fade" id="documents-modal" tabindex="-1" aria-labelledby="documentsModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="documentsModalLabel">Documents</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="currentDocuments && currentDocuments.length > 0">
              <div class="table-responsive">
                <table class="table table-bordered table-hover">
                  <thead class="table-light">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Document Name</th>
                    <th scope="col">Upload Date</th>
                    <th scope="col">Actions</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(doc, index) in currentDocuments" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ doc.documentName }}</td>
                    <td>{{ formatDateWithTime(doc.uploadedAt) }}</td>
                    <td>
                      <div class="d-flex">
                        <a :href="doc.documentPath" target="_blank" class="btn btn-sm btn-primary me-2">
                          <i class="mdi mdi-eye"></i> View
                        </a>
                        <a :href="doc.documentPath" download class="btn btn-sm btn-success">
                          <i class="mdi mdi-download"></i> Download
                        </a>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else class="text-center p-4">
              <div class="alert alert-warning">No documents available for this termination.</div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Clearance Status Modal -->
    <div class="modal fade" id="clearance-modal" tabindex="-1" aria-labelledby="clearanceModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="clearanceModalLabel">
              Clearance Status for {{ selectedTermination ? selectedTermination.employeeName : '' }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="selectedTermination && selectedTermination.clearanceInfo">
              <div class="row mb-4">
                <div class="col-12">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <h6 class="mb-0">Overall Clearance Status:</h6>
                    <span
                        class="badge py-2 px-3"
                        :class="calculateOverallClearance(selectedTermination.clearanceInfo) >= 100 ? 'bg-success' : 'bg-warning'"
                    >
                      {{ calculateOverallClearance(selectedTermination.clearanceInfo) }}% Complete
                    </span>
                  </div>
                  <div class="progress" style="height: 20px;">
                    <div
                        class="progress-bar"
                        :class="calculateOverallClearance(selectedTermination.clearanceInfo) >= 100 ? 'bg-success' : calculateOverallClearance(selectedTermination.clearanceInfo) >= 70 ? 'bg-info' : 'bg-warning'"
                        role="progressbar"
                        :style="`width: ${calculateOverallClearance(selectedTermination.clearanceInfo)}%`"
                        :aria-valuenow="calculateOverallClearance(selectedTermination.clearanceInfo)"
                        aria-valuemin="0"
                        aria-valuemax="100"
                    >
                      {{ calculateOverallClearance(selectedTermination.clearanceInfo) }}%
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mb-4">
                <div class="col-md-6">
                  <div class="clearance-item mb-3">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                      <div>
                        <i class="mdi mdi-laptop me-1"></i> IT Department Clearance
                      </div>
                      <span class="badge" :class="selectedTermination.clearanceInfo.itClearance ? 'bg-success' : 'bg-danger'">
                        {{ selectedTermination.clearanceInfo.itClearance ? 'Cleared' : 'Pending' }}
                      </span>
                    </div>
                    <small class="text-muted">Returned all company devices, access cards, etc.</small>
                  </div>

                  <div class="clearance-item mb-3">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                      <div>
                        <i class="mdi mdi-cash-multiple me-1"></i> Finance Department Clearance
                      </div>
                      <span class="badge" :class="selectedTermination.clearanceInfo.financeClearance ? 'bg-success' : 'bg-danger'">
                        {{ selectedTermination.clearanceInfo.financeClearance ? 'Cleared' : 'Pending' }}
                      </span>
                    </div>
                    <small class="text-muted">Settled all pending accounts, advances, etc.</small>
                  </div>

                  <div class="clearance-item mb-3">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                      <div>
                        <i class="mdi mdi-account-group me-1"></i> HR Department Clearance
                      </div>
                      <span class="badge" :class="selectedTermination.clearanceInfo.hrClearance ? 'bg-success' : 'bg-danger'">
                        {{ selectedTermination.clearanceInfo.hrClearance ? 'Cleared' : 'Pending' }}
                      </span>
                    </div>
                    <small class="text-muted">Completed exit interview, handover notes, etc.</small>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="clearance-item mb-3">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                      <div>
                        <i class="mdi mdi-office-building me-1"></i> Admin Department Clearance
                      </div>
                      <span class="badge" :class="selectedTermination.clearanceInfo.adminClearance ? 'bg-success' : 'bg-danger'">
                        {{ selectedTermination.clearanceInfo.adminClearance ? 'Cleared' : 'Pending' }}
                      </span>
                    </div>
                    <small class="text-muted">Returned office keys, parking cards, etc.</small>
                  </div>

                  <div class="clearance-item mb-3">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                      <div>
                        <i class="mdi mdi-account-supervisor me-1"></i> Department Head Clearance
                      </div>
                      <span class="badge" :class="selectedTermination.clearanceInfo.deptClearance ? 'bg-success' : 'bg-danger'">
                        {{ selectedTermination.clearanceInfo.deptClearance ? 'Cleared' : 'Pending' }}
                      </span>
                    </div>
                    <small class="text-muted">Completed knowledge transfer, handover, etc.</small>
                  </div>

                  <div class="clearance-item mb-3">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                      <div>
                        <i class="mdi mdi-shield-account me-1"></i> Security Department Clearance
                      </div>
                      <span class="badge" :class="selectedTermination.clearanceInfo.securityClearance ? 'bg-success' : 'bg-danger'">
                        {{ selectedTermination.clearanceInfo.securityClearance ? 'Cleared' : 'Pending' }}
                      </span>
                    </div>
                    <small class="text-muted">Returned ID badge, security tokens, etc.</small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="card bg-light">
                    <div class="card-header">
                      <h6 class="mb-0">Clearance Notes</h6>
                    </div>
                    <div class="card-body">
                      <p v-if="selectedTermination.clearanceInfo.clearanceNotes">
                        {{ selectedTermination.clearanceInfo.clearanceNotes }}
                      </p>
                      <p v-else class="text-muted">No clearance notes available.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="text-center p-4">
              <div class="alert alert-warning">No clearance information available for this termination.</div>
            </div>
          </div>
          <div class="modal-footer">
            <button
                v-if="selectedTermination && selectedTermination.status && selectedTermination.status.toLowerCase() === 'pending'"
                type="button"
                class="btn btn-primary me-2"
                @click="editClearance(selectedTermination)"
            >
              Edit Clearance
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit Clearance Modal -->
    <div class="modal fade" id="edit-clearance-modal" tabindex="-1" aria-labelledby="editClearanceModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title" id="editClearanceModalLabel">Update Clearance Status</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form id="updateClearanceForm" @submit.prevent="updateClearance">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <div class="form-check">
                      <input
                          class="form-check-input"
                          type="checkbox"
                          id="editItClearance"
                          v-model="editClearanceData.itClearance"
                      >
                      <label class="form-check-label" for="editItClearance">
                        IT Department Clearance
                      </label>
                    </div>
                    <small class="text-muted">Returned all company devices, access cards, etc.</small>
                  </div>

                  <div class="mb-3">
                    <div class="form-check">
                      <input
                          class="form-check-input"
                          type="checkbox"
                          id="editFinanceClearance"
                          v-model="editClearanceData.financeClearance"
                      >
                      <label class="form-check-label" for="editFinanceClearance">
                        Finance Department Clearance
                      </label>
                    </div>
                    <small class="text-muted">Settled all pending accounts, advances, etc.</small>
                  </div>

                  <div class="mb-3">
                    <div class="form-check">
                      <input
                          class="form-check-input"
                          type="checkbox"
                          id="editHrClearance"
                          v-model="editClearanceData.hrClearance"
                      >
                      <label class="form-check-label" for="editHrClearance">
                        HR Department Clearance
                      </label>
                    </div>
                    <small class="text-muted">Completed exit interview, handover notes, etc.</small>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="mb-3">
                    <div class="form-check">
                      <input
                          class="form-check-input"
                          type="checkbox"
                          id="editAdminClearance"
                          v-model="editClearanceData.adminClearance"
                      >
                      <label class="form-check-label" for="editAdminClearance">
                        Admin Department Clearance
                      </label>
                    </div>
                    <small class="text-muted">Returned office keys, parking cards, etc.</small>
                  </div>

                  <div class="mb-3">
                    <div class="form-check">
                      <input
                          class="form-check-input"
                          type="checkbox"
                          id="editDeptClearance"
                          v-model="editClearanceData.deptClearance"
                      >
                      <label class="form-check-label" for="editDeptClearance">
                        Department Head Clearance
                      </label>
                    </div>
                    <small class="text-muted">Completed knowledge transfer, handover, etc.</small>
                  </div>

                  <div class="mb-3">
                    <div class="form-check">
                      <input
                          class="form-check-input"
                          type="checkbox"
                          id="editSecurityClearance"
                          v-model="editClearanceData.securityClearance"
                      >
                      <label class="form-check-label" for="editSecurityClearance">
                        Security Department Clearance
                      </label>
                    </div>
                    <small class="text-muted">Returned ID badge, security tokens, etc.</small>
                  </div>
                </div>

                <div class="col-12 mt-3">
                  <div class="mb-3">
                    <label for="editClearanceNotes" class="form-label">Clearance Notes</label>
                    <textarea
                        class="form-control"
                        id="editClearanceNotes"
                        rows="3"
                        placeholder="Enter any specific notes about clearance status"
                        v-model="editClearanceData.clearanceNotes"
                    ></textarea>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button
                type="button"
                class="btn btn-primary"
                :disabled="isUpdatingClearance"
                @click="updateClearance"
            >
              <span v-if="isUpdatingClearance" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
              Update Clearance
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import {execute, authUrl} from "@/api";

export default {
  name: "SeparationTermination",
  components: {NavigationBar},
  data() {
    return {
      date: '',
      keyword: '',
      dateFrom: '',
      dateTo: '',
      selectedMonth: '',
      selectedDepartment: '',
      terminationsData: [],
      statistics: {
        totalTerminations: 0,
        resignations: 0,
        dismissals: 0,
        transfers: 0,
        deaths: 0,
        others: 0,
        pending: 0
      },
      employees: [],
      departments: [],
      isLoading: false,
      isApproving: null,
      isRejecting: null,
      isProcessingAction: false,
      isUpdatingClearance: false,
      message: '',
      confirmationModal: null,
      documentsModal: null,
      clearanceModal: null,
      editClearanceModal: null,
      selectedTerminationId: null,
      confirmationType: null,
      selectedTermination: null,
      currentDocuments: [],
      editClearanceData: {
        itClearance: false,
        financeClearance: false,
        hrClearance: false,
        adminClearance: false,
        deptClearance: false,
        securityClearance: false,
        clearanceNotes: ''
      }
    }
  },

  mounted() {
    // First fetch departments and employees, then fetch terminations
    this.getDepartments();
    this.getEmployeesList().then(() => {
      this.getTerminationsData();
    });

    // Initialize Bootstrap modals
    this.$nextTick(() => {
      this.confirmationModal = new bootstrap.Modal(document.getElementById('confirmation-modal'));
      this.documentsModal = new bootstrap.Modal(document.getElementById('documents-modal'));
      this.clearanceModal = new bootstrap.Modal(document.getElementById('clearance-modal'));
      this.editClearanceModal = new bootstrap.Modal(document.getElementById('edit-clearance-modal'));
    });
  },

  methods: {
    // Get terminations data
    getTerminationsData() {
      this.isLoading = true;
      const data = new FormData();
      data.append("function", "getTerminations");

      // Add filters if selected
      if (this.selectedMonth) {
        data.append("month", this.selectedMonth);
      }
      if (this.selectedDepartment) {
        data.append("department", this.selectedDepartment);
      }
      if (this.keyword) {
        data.append("keyword", this.keyword);
      }

      execute(data, authUrl)
          .then((res) => {
            this.isLoading = false;
            if (res.data.success) {
              // Check if data exists and has the right structure based on the provided JSON
              if (res.data.data && Array.isArray(res.data.data.terminations)) {
                // Update statistics from the metrics in the response
                if (res.data.data.metrics) {
                  this.statistics = {
                    totalTerminations: res.data.data.metrics.totalTerminations || 0,
                    resignations: res.data.data.metrics.resignationTerminations || 0,
                    dismissals: res.data.data.metrics.dismissalTerminations || 0,
                    transfers: res.data.data.metrics.transferTerminations || 0,
                    deaths: res.data.data.metrics.deathTerminations || 0,
                    others: res.data.data.metrics.otherTerminations || 0,
                    pending: res.data.data.metrics.pendingTerminations || 0
                  };
                }

                this.terminationsData = res.data.data.terminations.map((item) => {
                  // Parse the documents JSON string
                  let parsedDocuments = [];
                  try {
                    if (item.documents) {
                      parsedDocuments = JSON.parse(item.documents);
                    }
                  } catch (e) {
                    console.error("Error parsing documents:", e);
                  }

                  // Parse clearance info if it exists
                  let parsedClearanceInfo = null;
                  try {
                    if (item.clearanceInfo) {
                      parsedClearanceInfo = JSON.parse(item.clearanceInfo);
                    } else {
                      // Default clearance structure if none exists
                      parsedClearanceInfo = {
                        itClearance: false,
                        financeClearance: false,
                        hrClearance: false,
                        adminClearance: false,
                        deptClearance: false,
                        securityClearance: false,
                        clearanceNotes: ''
                      };
                    }
                  } catch (e) {
                    console.error("Error parsing clearance info:", e);
                    parsedClearanceInfo = {
                      itClearance: false,
                      financeClearance: false,
                      hrClearance: false,
                      adminClearance: false,
                      deptClearance: false,
                      securityClearance: false,
                      clearanceNotes: ''
                    };
                  }

                  return {
                    id: item.id,
                    employeeId: item.employeeId,
                    employeeName: item.employeeName || "N/A",
                    separationType: item.separationType || "N/A",
                    terminationDate: item.separationDate || "N/A",
                    lastWorkingDay: item.lastWorkingDay || "N/A",
                    description: item.description || "N/A",
                    documents: parsedDocuments,
                    clearanceInfo: parsedClearanceInfo,
                    departmentName: item.departmentName || "N/A",
                    departmentID: item.departmentID || "",
                    status: item.status || "pending",
                    approvedBy: item.approvedBy || null,
                    approvedAt: item.approvedAt || null,
                    rejectedBy: item.rejectedBy || null,
                    rejectedAt: item.rejectedAt || null,
                    createdAt: item.createdAt,
                    updatedAt: item.updatedAt
                  };
                });
              } else {
                this.terminationsData = [];
                console.log("No terminations data found or incorrect data format");
              }
            } else {
              this.message = res.data.message;
              this.terminationsData = [];
            }
          })
          .catch((e) => {
            this.isLoading = false;
            this.message = e.message;
            this.terminationsData = [];
          });
    },

    // Get terminations statistics
    getTerminationsStatistics() {
      // This function is now redundant since we get metrics in the getTerminations call
      // But we'll keep it as a fallback in case we need to fetch stats separately
      const data = new FormData();
      data.append("function", "getTerminationStats");

      // Add filters if selected
      if (this.selectedMonth) {
        data.append("month", this.selectedMonth);
      }
      if (this.selectedDepartment) {
        data.append("department", this.selectedDepartment);
      }

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              if (res.data.data && res.data.data.metrics) {
                this.statistics = {
                  totalTerminations: res.data.data.metrics.totalTerminations || 0,
                  resignations: res.data.data.metrics.resignationTerminations || 0,
                  dismissals: res.data.data.metrics.dismissalTerminations || 0,
                  transfers: res.data.data.metrics.transferTerminations || 0,
                  deaths: res.data.data.metrics.deathTerminations || 0,
                  others: res.data.data.metrics.otherTerminations || 0,
                  pending: res.data.data.metrics.pendingTerminations || 0
                };
              } else {
                // Default statistics if API doesn't return the expected structure
                this.statistics = {
                  totalTerminations: 0,
                  resignations: 0,
                  dismissals: 0,
                  transfers: 0,
                  deaths: 0,
                  others: 0,
                  pending: 0
                };
              }
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    // Get employees list for dropdown
    async getEmployeesList() {
      const data = new FormData();
      data.append("function", "getEmployees");
      data.append("status", "active");

      try {
        const res = await execute(data, authUrl);
        if (res.data.success) {
          // Using the actual response structure shown in your example
          this.employees = res.data.data.employees
              .filter(employee => employee.usage_status === "in_use") // Only show active employees
              .map(employee => {
                const middleName = employee.middleName ? ` ${employee.middleName} ` : ' ';
                return {
                  id: employee.id,
                  name: `${employee.firstName}${middleName}${employee.lastName}`,
                  value: employee.id,
                  department: employee.departmentID,
                  designation: employee.designation
                };
              });
        } else {
          this.message = res.data.message;
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    // Handle create termination form submission
    submitTermination(event) {
      event.preventDefault();

      const form = event.target;
      const employeeId = form.selectEmployee.value;
      const separationType = form.separationType.value;
      const separationDate = form.separationDate.value;
      const lastWorkingDay = form.lastWorkingDay.value;
      const description = form.description.value;
      const documents = form.uploadDocuments.files;

      // Get clearance information
      const clearanceInfo = {
        itClearance: form.itClearance ? form.itClearance.checked : false,
        financeClearance: form.financeClearance ? form.financeClearance.checked : false,
        hrClearance: form.hrClearance ? form.hrClearance.checked : false,
        adminClearance: form.adminClearance ? form.adminClearance.checked : false,
        deptClearance: form.deptClearance ? form.deptClearance.checked : false,
        securityClearance: form.securityClearance ? form.securityClearance.checked : false,
        clearanceNotes: form.clearanceNotes ? form.clearanceNotes.value : ''
      };

      if (!employeeId || !separationType || !separationDate || !lastWorkingDay) {
        this.message = "Please fill all required fields";
        return;
      }

      this.isLoading = true;

      // Find the selected employee to include their details
      const selectedEmployee = this.employees.find(emp => emp.id === employeeId);

      const data = new FormData();
      data.append("function", "createTermination");
      data.append("employeeId", employeeId);
      data.append("employeeName", selectedEmployee ? selectedEmployee.name : "");
      data.append("separationType", separationType);
      data.append("separationDate", separationDate);
      data.append("lastWorkingDay", lastWorkingDay);
      data.append("description", description);
      data.append("clearanceInfo", JSON.stringify(clearanceInfo));

      // Include department info if available
      if (selectedEmployee && selectedEmployee.department) {
        data.append("departmentId", selectedEmployee.department);
      }

      // Include designation if available
      if (selectedEmployee && selectedEmployee.designation) {
        data.append("designation", selectedEmployee.designation);
      }

      // Append documents if any
      if (documents.length > 0) {
        for (let i = 0; i < documents.length; i++) {
          data.append("documents[]", documents[i]);
        }
      }

      execute(data, authUrl)
          .then((res) => {
            this.isLoading = false;
            if (res.data.success) {
              // Close modal
                this.closeAllModals()
              // Refresh data
              this.getTerminationsData();
              this.getTerminationsStatistics();
              this.message = "Termination created successfully";

              // Reset form
              form.reset();
            } else {
              this.message = res.data.message || "Failed to create termination. Please try again.";
            }
          })
          .catch((e) => {
            this.isLoading = false;
            this.message = e.message || "An error occurred. Please try again.";
          });
    },

    closeAllModals() {
      // First close all modals using Bootstrap's API
      const modals = document.querySelectorAll('.modal.show');
      modals.forEach(modal => {
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) {
          modalInstance.hide();
        }
      });

      // Then remove any lingering backdrop elements
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(backdrop => {
        backdrop.remove();
      });

      // Finally, fix the body by removing modal-open class and inline styles
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('padding-right');
      document.body.style.removeProperty('overflow');
    },

    // Handle month selection change
    handleMonthChange(event) {
      this.selectedMonth = event.target.value;
      this.getTerminationsData();
    },

    // Get departments list
    getDepartments() {
      const data = new FormData();
      data.append("function", "getDepartments");

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              if (res.data.data && Array.isArray(res.data.data.departments)) {
                this.departments = res.data.data.departments;
              } else {
                console.log("No departments data found or incorrect data format");
              }
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    // Handle department selection change
    handleDepartmentChange(event) {
      this.selectedDepartment = event.target.value;
      this.getTerminationsData();
    },

    // Handle search input
    handleSearch(event) {
      this.keyword = event.target.value;
      this.getTerminationsData();
    },

    // Get status badge class based on status
    getStatusBadgeClass(status) {
      if (!status) return 'bg-warning';

      const statusLower = status.toLowerCase();
      switch(statusLower) {
        case 'approved':
          return 'bg-success';
        case 'rejected':
          return 'bg-danger';
        default:
          return 'bg-warning';
      }
    },

    // Format status text for display
    formatStatus(status) {
      if (!status) return 'Pending';

      const statusLower = status.toLowerCase();
      if (statusLower === 'pending') return 'Pending';
      return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    },

    // Show confirmation modal before approval/rejection
    showConfirmationModal(id, type) {
      this.selectedTerminationId = id;
      this.confirmationType = type;

      // Find the termination data to display in confirmation
      this.selectedTermination = this.terminationsData.find(item => item.id === id);

      // Show modal
      if (this.confirmationModal) {
        this.confirmationModal.show();
      } else {
        // If modal isn't initialized yet, initialize it now
        this.confirmationModal = new bootstrap.Modal(document.getElementById('confirmation-modal'));
        this.confirmationModal.show();
      }
    },

    // Confirm action (approve or reject)
    confirmAction() {
      this.isProcessingAction = true;

      if (this.confirmationType === 'approve') {
        this.approveTermination(this.selectedTerminationId);
      } else if (this.confirmationType === 'reject') {
        this.rejectTermination(this.selectedTerminationId);
      }
    },

    // Approve termination
    approveTermination(id) {
      const data = new FormData();
      data.append("function", "approveTermination");
      data.append("terminationId", id);

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              // Update the status in the local data without fetching again
              const index = this.terminationsData.findIndex(item => item.id === id);
              if (index !== -1) {
                this.terminationsData[index].status = 'approved';
                this.terminationsData[index].approvedBy = 'Current User';
                this.terminationsData[index].approvedAt = new Date().toISOString().slice(0, 19).replace('T', ' ');
              }
              this.message = "Termination successfully approved";

              // Close confirmation modal
              if (this.confirmationModal) {
                this.confirmationModal.hide();
              }
            } else {
              this.message = res.data.message || "Failed to approve termination";
            }
            this.isProcessingAction = false;
          })
          .catch((e) => {
            this.isProcessingAction = false;
            this.message = e.message || "An error occurred while approving";

            // Close confirmation modal
            if (this.confirmationModal) {
              this.confirmationModal.hide();
            }
          });
    },

    // Reject termination
    rejectTermination(id) {
      const data = new FormData();
      data.append("function", "rejectTermination");
      data.append("terminationId", id);

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              // Update the status in the local data without fetching again
              const index = this.terminationsData.findIndex(item => item.id === id);
              if (index !== -1) {
                this.terminationsData[index].status = 'rejected';
                this.terminationsData[index].rejectedBy = 'Current User';
                this.terminationsData[index].rejectedAt = new Date().toISOString().slice(0, 19).replace('T', ' ');
              }
              this.message = "Termination successfully rejected";

              // Close confirmation modal
              if (this.confirmationModal) {
                this.confirmationModal.hide();
              }
            } else {
              this.message = res.data.message || "Failed to reject termination";
            }
            this.isProcessingAction = false;
          })
          .catch((e) => {
            this.isProcessingAction = false;
            this.message = e.message || "An error occurred while rejecting";

            // Close confirmation modal
            if (this.confirmationModal) {
              this.confirmationModal.hide();
            }
          });
    },

    // Format date for display
    formatDate(dateString) {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    },

    // Format date with time
    formatDateWithTime(dateTimeString) {
      if (!dateTimeString) return "N/A";
      const date = new Date(dateTimeString);
      return `${date.toLocaleDateString('en-US', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      })} ${date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit'
      })}`;
    },

    // View documents in modal
    viewDocuments(documents) {
      this.currentDocuments = documents;

      if (this.documentsModal) {
        this.documentsModal.show();
      } else {
        // If modal isn't initialized yet, initialize it now
        this.documentsModal = new bootstrap.Modal(document.getElementById('documents-modal'));
        this.documentsModal.show();
      }
    },

    // View clearance status
    viewClearanceStatus(termination) {
      this.selectedTermination = termination;

      if (this.clearanceModal) {
        this.clearanceModal.show();
      } else {
        // If modal isn't initialized yet, initialize it now
        this.clearanceModal = new bootstrap.Modal(document.getElementById('clearance-modal'));
        this.clearanceModal.show();
      }
    },

    // Calculate overall clearance percentage
    calculateOverallClearance(clearanceInfo) {
      if (!clearanceInfo) return 0;

      const keys = ['itClearance', 'financeClearance', 'hrClearance', 'adminClearance', 'deptClearance', 'securityClearance'];
      const total = keys.length;
      let completed = 0;

      keys.forEach(key => {
        if (clearanceInfo[key]) {
          completed += 1;
        }
      });

      return Math.round((completed / total) * 100);
    },

    // Edit clearance info
    editClearance(termination) {
      // Close the current clearance modal
      if (this.clearanceModal) {
        this.clearanceModal.hide();
      }

      // Initialize the edit data with the current values
      this.editClearanceData = { ...termination.clearanceInfo };
      this.selectedTermination = termination;

      // Show the edit modal
      if (this.editClearanceModal) {
        this.editClearanceModal.show();
      } else {
        this.editClearanceModal = new bootstrap.Modal(document.getElementById('edit-clearance-modal'));
        this.editClearanceModal.show();
      }
    },

    // Update clearance info
    updateClearance() {
      this.isUpdatingClearance = true;

      const data = new FormData();
      data.append("function", "updateClearance");
      data.append("terminationId", this.selectedTermination.id);
      data.append("clearanceInfo", JSON.stringify(this.editClearanceData));

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              // Update local data
              const index = this.terminationsData.findIndex(item => item.id === this.selectedTermination.id);
              if (index !== -1) {
                this.terminationsData[index].clearanceInfo = { ...this.editClearanceData };
                this.selectedTermination = this.terminationsData[index];
              }

              this.message = "Clearance information updated successfully";

              // Close edit modal and show clearance modal again
              if (this.editClearanceModal) {
                this.editClearanceModal.hide();
              }

              // Show clearance modal again
              setTimeout(() => {
                if (this.clearanceModal) {
                  this.clearanceModal.show();
                }
              }, 500);
            } else {
              this.message = res.data.message || "Failed to update clearance information";
            }

            this.isUpdatingClearance = false;
          })
          .catch((e) => {
            this.isUpdatingClearance = false;
            this.message = e.message || "An error occurred while updating clearance";

            // Close edit modal
            if (this.editClearanceModal) {
              this.editClearanceModal.hide();
            }
          });
    },

    // Generate clearance report
    generateClearanceReport() {
      // This would typically make an API call to generate a report
      // For now, we'll just show a message
      this.message = "Generating clearance report... This feature is coming soon!";

      // In real implementation, call API:
      /*
      const data = new FormData();
      data.append("function", "generateClearanceReport");

      if (this.selectedMonth) {
        data.append("month", this.selectedMonth);
      }
      if (this.selectedDepartment) {
        data.append("department", this.selectedDepartment);
      }

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              // Handle success, e.g., open report in new window or download
              window.open(res.data.data.reportUrl, '_blank');
              this.message = "Report generated successfully";
            } else {
              this.message = res.data.message || "Failed to generate report";
            }
          })
          .catch((e) => {
            this.message = e.message || "An error occurred while generating report";
          });
      */
    }
  }
}
</script>
<style scoped>
/* Add any custom styles here if needed */
</style>